














































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import Loading from "../general/Loading.vue";

import DemoServer from "../../shared/DemoServer";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";

export default Vue.extend({
  name: "SettingsInfo",
  components: {
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      DemoServer: DemoServer,
      UserPermissionRank: UserPermissionRank,
      checkModuleIsActivated: checkModuleIsActivated,
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
  },
  methods: {},
  watch: {},
  computed: {
    baseUrl(): string {
      return window.location.protocol + "//" + window.location.hostname + "/";
    },
  },
});
